import React, { useState } from "react";
import { useSelector } from "react-redux";

// @material-ui/core components
import {
	CardContent,
	Collapse,
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";

// custom components
import Card from "../../components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import ExpandCollapseIcon from "../ExpandCollapseIcon.jsx";

import {
	AcreInchPerAcreUnits,
	AcreInchPerYearUnits,
	CO2Units,
	CO2PerAcreYearUnits,
	CO2PerDollarUnits,
	CO2PerYearUnits,
	formatDollars,
	formatResult,
} from "helpers/report.js";

export default function GHGOverallReportTable(props) {
	const { classes, reportData, handleFundsClick } = props;
	const user = useSelector((state) => state.user);

	//Todo: make a base class for all these report page cards to inherit from that handles the collapse functionality?
	// would take a title and children as props
	const [collapsed, setCollapsed] = useState(false);

	function toggleCollapse() {
		setCollapsed(!collapsed);
	}

	return (
		<Card id="ghgOverallReport">
			<CardHeader style={{ backgroundColor: "#cc66ff" }} onClick={toggleCollapse}>
				<ExpandCollapseIcon collapsed={collapsed} />
				<Typography align="center" variant="h5">
					SWEEP Project Key Outputs
				</Typography>
			</CardHeader>
			<Collapse in={!collapsed}>
				<CardContent>
					<Table style={{ marginBottom: 10 }}>
						<TableHead className={classes.tableHeader}>
							<TableRow>
								<TableCell>Results</TableCell>
								<TableCell>Projected Reductions</TableCell>
								<TableCell>Units</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							<TableRow>
								<TableCell>Pumping GHG Benefits per Growing Season*</TableCell>
								<TableCell align="right">{formatResult(reportData.pumpingReport.yearlyGHGBenefits)}</TableCell>
								<TableCell>
									<CO2PerYearUnits />
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>N2O GHG Benefits per Growing Season*</TableCell>
								<TableCell align="right">{formatResult(reportData.overallReport.convertedN2OBenefits)}</TableCell>
								<TableCell>
									<CO2PerYearUnits />
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>Total GHG Benefits per Growing Season*</TableCell>
								<TableCell align="right">{formatResult(reportData.overallReport.yearlyGHGBenefits)}</TableCell>
								<TableCell>
									<CO2PerYearUnits />
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>Yearly Pre-Project Water Use*</TableCell>
								<TableCell align="right">{formatResult(reportData.waterReport.beforeWaterUse / 3)}</TableCell>
								<TableCell>
									<AcreInchPerYearUnits />
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>Yearly Water Savings*</TableCell>
								<TableCell align="right">{formatResult(reportData.waterReport.waterSavings / 3)}</TableCell>
								<TableCell>
									<AcreInchPerYearUnits />
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>Water Savings Percentage*</TableCell>
								<TableCell align="right">{formatResult(reportData.waterReport.percentSavings)}</TableCell>
								<TableCell>%</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>Total Acres Impacted*</TableCell>
								<TableCell align="right">{formatResult(reportData.waterReport.totalArea)}</TableCell>
								<TableCell>acres</TableCell>
							</TableRow>
							{/* <TableRow>
								<TableCell>Net GHG Benefits over Useful 10-yr Life</TableCell>
								<TableCell align="right">{formatResult(reportData.overallReport.tenYearGHGBenefits)}</TableCell>
								<TableCell>
									<CO2Units />
								</TableCell>
							</TableRow> */}

							<TableRow>
								<TableCell>GHG Benefits per Acre-Year</TableCell>
								<TableCell align="right">{formatResult(reportData.overallReport.ghgBenefitsPerAcreYear)}</TableCell>
								<TableCell>
									<CO2PerAcreYearUnits />
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell style={{ paddingTop: 0, paddingBottom: 0 }}>
									Total Funds Requested
									<IconButton onClick={handleFundsClick}>
										<EditIcon />
									</IconButton>
								</TableCell>
								<TableCell align="right">{formatDollars(user.fundsRequested)}</TableCell>
								<TableCell>dollars</TableCell>
							</TableRow>
							<TableRow>
								<TableCell>Total GHG Emission Reductions per Dollar Requested</TableCell>
								<TableCell align="right">
									{formatResult(reportData.overallReport.emissionReductionsPerFundsRequested)}
								</TableCell>
								<TableCell>
									<CO2PerDollarUnits />
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
					<span style={{ marginLeft: 8 }}>* To be transferred to application</span>
				</CardContent>
			</Collapse>
		</Card>
	);
}
